import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload, callback) => req.list(
  c.GET_LIST,
  'api/v1/administrators/special_permits/settings',
  payload,
  callback,
);

export const updateComponent = (payload, callback) => req.update(
  c.UPDATE_COMPONENT,
  'api/v1/administrators/special_permits/settings/update',
  payload,
  callback,
);
